import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { CenteredMainDialog } from "../../../_UI/StyledComponents/StyledComponents";
import { getClientNameForConnectedAuthData } from "../services/client.mapper";

const ClientDeleteDialog = () => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <DeleteDialog>
            <CenteredMainDialog>
                Soll die Verbindung zu{" "}
                {getClientNameForConnectedAuthData(clientReducer.clients, clientReducer.editConnectedAuthData)} für{" "}
                {clientReducer.editConnectedAuthData.title} wirklich gelöscht werden?{" "}
            </CenteredMainDialog>
        </DeleteDialog>
    );
};

export default ClientDeleteDialog;

const DeleteDialog = styled.div`
    display: grid;
    row-gap: var(--gap-m);
`;
